import { MemberBadgeDto } from '@careapp-group/ng-sdk';
import { CaEntityState } from '../entity-state/entity-state';
import { CaEntityReducer } from '../entity-state/entity-reducer';
import { BaseFilterType } from '../entity-state/entity-actions-factory';
import { MemberBadgesActions } from './member-badges.actions';

export interface MemberBadgeState extends CaEntityState<MemberBadgeDto> {}

export class MemberBadgesReducer extends CaEntityReducer<MemberBadgeDto, BaseFilterType> {}

export const state = new MemberBadgesReducer(MemberBadgesActions);

export function reducer(...args) {
  return state.reducer.apply(state, args);
}
